import { Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { PdfGridDimension } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';

interface ResolvedCell {
  left: number;
  top: number;
  width: number;
  height: number;
}

@Component({
  selector: 'bhub-pdf-grid-cell',
  standalone: false,
  templateUrl: './pdf-grid-cell.component.html',
  styleUrls: ['./pdf-grid-cell.component.scss']
})
export class PdfGridCellComponent extends BaseCellComponent {
  gridCells: ResolvedCell[] = [];
  showBorders = true;
  borderColor = '#000000';
  borderThickness = 1;
  backgroundColor = '';

  protected initializeCell(): void {
    this.updateGrid();
  }

  protected onCellOrDataChange(): void {
    this.updateGrid();
  }

  protected onCellUpdate(): void {
    this.updateGrid();
  }

  protected onDataSet(data: any): void {}

  reloadData(): void {
    this.updateGrid();
  }

  private updateGrid(): void {
    if (!this.cell) return;

    this.showBorders = this.getConfigValue('pdfGridShowBorders', true);
    this.borderColor = this.getConfigValue('pdfGridBorderColor', '#000000');
    this.borderThickness = this.getConfigValue('pdfGridBorderThickness', 1);
    this.backgroundColor = this.getConfigValue('pdfGridBackgroundColor', '');

    const columns: PdfGridDimension[] = this.getConfigValue('pdfGridColumns', []);
    const rows: PdfGridDimension[] = this.getConfigValue('pdfGridRows', []);

    if (columns.length === 0 || rows.length === 0) {
      this.gridCells = [];
      return;
    }

    const totalWidth = this.cell.position.width;
    const totalHeight = this.cell.position.height;

    const colWidths = this.resolveDimensions(columns, totalWidth, 'width');
    const rowHeights = this.resolveDimensions(rows, totalHeight, 'height');

    this.gridCells = [];
    let top = 0;
    for (const rh of rowHeights) {
      let left = 0;
      for (const cw of colWidths) {
        this.gridCells.push({ left, top, width: cw, height: rh });
        left += cw;
      }
      top += rh;
    }
  }

  private resolveDimensions(dims: PdfGridDimension[], total: number, fixedKey: 'width' | 'height'): number[] {
    let fixedSum = 0;
    let weightSum = 0;

    for (const d of dims) {
      if (d[fixedKey]) {
        fixedSum += d[fixedKey]!;
      } else {
        weightSum += d.weight || 1;
      }
    }

    const remaining = Math.max(0, total - fixedSum);

    return dims.map(d => {
      if (d[fixedKey]) return d[fixedKey]!;
      return remaining * ((d.weight || 1) / weightSum);
    });
  }
}
